import { inject,Injectable } from '@angular/core';
import { DpModalService, HeaderAction } from '@docpath/webcomponents';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import { Dge, DgeState } from '../../models/dge';
import { EnginesService } from '../../services/engines.service';
import { EnginesHttpService } from '../../services/engines-http.service';


@Injectable({
    providedIn: 'root'
})
export class EnginesHeaderService {

    private readonly i18nPrefix = 'engines-config';

    private readonly modalService = inject(DpModalService);
    private readonly enginesHttpService = inject(EnginesHttpService);
    private readonly enginesService = inject(EnginesService);

    getRightActions(): HeaderAction[] {

        const rightActions = [];

        rightActions.push(this.initSearchAction());

        return rightActions;

    }

    getMoreActions(selectedDges: Dge[]): HeaderAction[] {

        const actions = [];

        if (selectedDges.length === 1) {
            const dgeSelected = selectedDges[0];
            if (dgeSelected.currentState !== DgeState.UNLINKED) {
                actions.push(this.initUnlinkAction(dgeSelected));
            }

            actions.push(this.initDeleteAction(dgeSelected));
        }

        return actions;

    }

    private initSearchAction(): HeaderAction {

        const action = new HeaderAction(`${this.i18nPrefix}.header.search.label`, { cssClass: 'btn btn-dpsecondary' });
        action.tooltip = `${this.i18nPrefix}.header.search.tooltip`;
        action.icon = faMagnifyingGlass;

        return action;

    }

    getSearchAction(actions: HeaderAction[]): HeaderAction {
        return actions[0];
    }

    private initUnlinkAction(dge: Dge): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.unlink.label`);

        action.tooltip = `${this.i18nPrefix}.header.unlink.tooltip`;
        action.action = () => this.unlinkDge(dge, false);

        return action;
    }

    private unlinkDge(dge: Dge, remove: boolean): void {

        const modal = this.modalService.openQuestion(`${this.i18nPrefix}.modal.unlink-question`);

        modal.componentInstance.accepted.subscribe(() => {
            this.enginesHttpService.unlinkDge(dge, remove, () => {
                if (remove) {
                    this.enginesHttpService.deleteDge(dge, () => {
                        this.enginesService.notifyEngineChange();
                    });
                } else {
                    this.enginesService.notifyEngineChange();
                }
            });
        });

    }

    private initDeleteAction(dge: Dge): HeaderAction {
        const action = new HeaderAction(`${this.i18nPrefix}.header.delete.label`);

        action.tooltip = `${this.i18nPrefix}.header.delete.tooltip`;
        action.action = () => this.deleteDge(dge);

        return action;
    }

    private deleteDge(dge: Dge): void {

        const modal = this.modalService.openQuestion(`${this.i18nPrefix}.modal.delete-question`);

        modal.componentInstance.accepted.subscribe(() => {
            if (dge.currentState === DgeState.UNLINKED) {
                this.enginesHttpService.deleteDge(dge, () => {
                    this.enginesService.notifyEngineChange();
                });
            } else {
                this.unlinkDge(dge, true);
            }
        });

    }

}